import { Box, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC, useCallback, useEffect, useState } from 'react'
import { staticStrings } from '../../data/static/strings'
import { useStores } from '../../data/store'
import { ApiCredentialsTab } from './ApiCredentialsTab'
import styles from './styles'
import { TabBarHeader, tabTitles } from './TabBarHeader'
import { UserManagementTab } from './UserManagementTab'
import { WebhooksTab } from './WebhooksTab'
import { AddOrEditWebhookDialog } from './WebhooksTab/AddOrEditWebhookDialog'

const Settings: FC = ({ route }) => {
  const {
    isUserManagementEnabled,
    isCreateUserTabEnabled,
    isAPICredentialsTabVisible,
    canViewWebHooks,
    canAddWebhooks,
  } = useStores((store) => ({
    isUserManagementEnabled: store.userManagement.isUserManagementEnabled,
    isCreateUserTabEnabled: store.userManagement.isCreateUserTabEnabled(),
    isAPICredentialsTabVisible: store.userManagement.isAPICredentialsTabVisible(),
    canViewWebHooks: store.userManagement.canViewWebHooks(),
    canAddWebhooks: store.userManagement.canAddWebhooks(),
  }))
  const isUserManagementTabEnabled = isUserManagementEnabled()

  const [selectedTab, setSelectedTab] = useState(0)
  const [highlightedTabString, toggleHighlightedTabString] = useState(
    tabTitles(isUserManagementTabEnabled, isAPICredentialsTabVisible, canViewWebHooks)[0]?.title ?? '',
  )
  const [showWebHookDialog, setShowWebHookDialog] = useState(false)
  const [webHookDialogData, setWebHookDialogData] = useState({ mode: 'add', data: {} })
  const navigation = useNavigation()

  const onTabSelection = useCallback((index: number, titleText: string) => {
    toggleHighlightedTabString(titleText)
    setSelectedTab(index)
  }, [])

  const passedData = route?.params ?? {}
  const isUserManagementTabHighlighted = highlightedTabString === staticStrings.userManagement

  useEffect(() => {
    if (passedData?.params) {
      const tabName = passedData?.params
      const arrName = tabTitles(isUserManagementTabEnabled, isAPICredentialsTabVisible, canViewWebHooks)
      const routeSelected = ({ title }: any) => {
        return title === tabName
      }
      let index = arrName.findIndex(routeSelected)
      setSelectedTab(index)
      toggleHighlightedTabString(tabName)
    }
  }, [canViewWebHooks, isAPICredentialsTabVisible, isUserManagementTabEnabled, passedData])

  return (
    <Box {...styles.maincontainer}>
      <Box {...styles.container} flex={1}>
        <Text {...styles.heading} testID="page-title">Settings</Text>
        <Box pv={30}>
          <TabBarHeader
            selectedTab={selectedTab}
            setSelectedTab={onTabSelection}
            onAddNewWebhookPress={() => {
              setWebHookDialogData({ mode: 'add', data: {} })
              setShowWebHookDialog(true)
            }}
            navigation={navigation}
            isUserManagementTabEnabled={isUserManagementTabEnabled}
            highlightedTabString={highlightedTabString}
            canCreateNewUser={isCreateUserTabEnabled}
            isAPICredentialsTabVisible={isAPICredentialsTabVisible}
            canViewWebHooks={canViewWebHooks}
            canAddWebhooks={canAddWebhooks}
          />
        </Box>
        {highlightedTabString === staticStrings.apiCredentials && <ApiCredentialsTab />}
        {highlightedTabString === staticStrings.Webhooks && (
          <>
            <AddOrEditWebhookDialog
              showWebHookDialog={showWebHookDialog}
              setShowWebHookDialog={setShowWebHookDialog}
              mode={webHookDialogData.mode}
            />
            <WebhooksTab
              onListItemClick={() => {
                setWebHookDialogData({ mode: 'view', data: {} })
                setShowWebHookDialog(true)
              }}
            />
          </>
        )}
        <UserManagementTab hide={!(isUserManagementTabHighlighted && isUserManagementTabEnabled)} />
      </Box>
    </Box>
  )
}

export default Settings
